import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/Button';
import { Card } from 'components/Card';
import { Modal } from 'components/Modal';
import { Heading } from 'components/Typography';
import { ScreenerResultsCtx } from 'domains/signup/screener/Components/ScreenerResultsSummary/context';
import { useScreenerResultsPDFDownload } from 'domains/signup/screener/data/pdf';
import { useModal } from 'utils/hooks/useModal';
import { Icon } from 'components/Icon';

const DOWNLOAD_FILE_NAME = 'Therapy Screener Results.pdf';

export const ScreenerResultsPDFSection: React.FC = () => {
  const { results } = useContext(ScreenerResultsCtx);
  const { t } = useTranslation();

  const { mutateAsync, data, isLoading, isSuccess } = useScreenerResultsPDFDownload();

  const { openModal, modalProps, closeModal } = useModal();

  const onGeneratePDF = () => {
    openModal();

    if (!isSuccess && !isLoading) {
      mutateAsync(results);
    }
  };

  return (
    <section>
      <Card className="bg-orchid-100">
        <Heading level="h4" className="mb-40">
          {t('screener.results.pdf.title')}
        </Heading>

        <Button size="lg" onClick={onGeneratePDF} className="sm-d:w-full">
          {t('screener.results.pdf.download')}
        </Button>
      </Card>

      <Modal {...modalProps}>
        <Heading level="h4" className="mb-40">
          {t('screener.results.pdf.modal.title')}
        </Heading>

        {isSuccess && data ? (
          <Button
            size="lg"
            as="a"
            onClick={closeModal}
            startAdornment={<Icon name="Download" className="mr-4" />}
            href={data}
            download={DOWNLOAD_FILE_NAME}
            className="sm-d:w-full"
          >
            {t(`screener.results.pdf.modal.download.ready`)}
          </Button>
        ) : (
          <Button
            size="lg"
            disabled
            loading
            loadingText={t(`screener.results.pdf.modal.download.loading`)}
            className="sm-d:w-full"
          />
        )}
      </Modal>
    </section>
  );
};
